import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SectionsChangesEvent } from '../../core/classes/sections-changes-event';
import { EventPoolService } from '../../core/event-pool.service';
import { DialogService } from '../../rl-common/dialogs/core/dialog.service';
import { FormType } from '../../rl-common/forms/shared/form-type.enum';
import { Action } from '../../rl-common/menu/action';
import { EntityType } from '../../rl-common/shared/shared/entity-type.enum';
import { SidePanelService } from '../../side-panel/core/side-panel.service';
import { Section } from '../../store/model/section.model';
import { SectionService } from '../core/section.service';
import { SectionItem } from '../shared/section-item';

@Component({
  selector: 'rl-section',
  templateUrl: './section.component.html',
  styleUrls: ['./section.component.scss']
})
export class SectionComponent implements OnInit {

  @Input() section : Section;
  @Input() isOpen : boolean = false;
  @Output() isOpenChange = new EventEmitter<boolean>();
  @Output() onDelete = new EventEmitter<number>();
  
  editMode : boolean;
  menuOptions : Action[];
  displayPageCount : boolean = false;

  constructor(private sectionService : SectionService , private dialogService : DialogService, private translate : TranslateService, private sidePanel : SidePanelService,
    private eventPool : EventPoolService) { }

  ngOnInit(): void {
    this.menuOptions = this.sectionService.getMenuOptions(this.section);
    this.section = new Section(this.section);
   }

   toggleOpenClose = () => {
    this.isOpen = !this.isOpen;
    this.isOpenChange.emit(this.isOpen);
  }

  edit(){
    this.editMode = true;
  }

  addItems(){
    this.sidePanel.openAddNewItem(FormType.ASSIGNMENT, EntityType.ASSIGNMENT, (item : SectionItem) => {
      this.section.add(item);      
      this.eventPool.update(new SectionsChangesEvent('ADD', EntityType.ASSIGNMENT, item));
      // scroll
    }, this.section);
  }

  delete = () => this.dialogService.openDeleteDialog(`${this.translate.instant('list.sections.deleteConfirm')}: ${this.section.name}?`, () => this.sectionService.delete(this.section).subscribe(() => this.onDelete.emit()));
  
}